import GlobalStyleComponent from "/opt/build/repo/src/styles/GlobalStyleComponent";
export default GlobalStyleComponent;
